"use client";
import React, { useEffect } from "react";
import Link from "next/link";
import { Col, Container, Row } from "react-bootstrap";
import TiltedCard from "@/components/TiltedCard";
import portfolio from "../../public/assets/images/portfolio/portfolio.png";
import AboutHeroSection from "@/components/AboutHeroSection";

const PortfolioPage = ({ projectsView }) => {
  useEffect(() => {
    const reveal = () => {
      const reveals = document.querySelectorAll(".reveal");

      reveals.forEach((element) => {
        const windowHeight = window.innerHeight;
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 10;

        if (
          elementTop < windowHeight - elementVisible &&
          !element.classList.contains("active")
        ) {
          element.classList.add("active");
        }
      });
    };

    window.addEventListener("scroll", reveal);
    reveal(); // trigger on load

    return () => window.removeEventListener("scroll", reveal);
  }, []);
  return (
    <>
      <AboutHeroSection
        pillText="~ Our Portfolio ~"
        title="Showcasing Our"
        highlight="finest work"
        description=" Dive into our curated portfolio of impactful software solutions. From fintech to e-commerce, we design and develop purposeful digital experiences that drive results. With deep industry expertise, we're building the future with futuristic tech."
        image={portfolio}
        imageAlt="Finest work"
      />
      <section className="py-5">
        <Container>
          <Row className="">
            {projectsView.map((item, i) => (
              <Col xl={6} md={12} key={i}>
                <Link
                  href={`/portfolio/${item?.link}`}
                  aria-label={`View More Details of ${item?.name}`}
                >
                  <TiltedCard
                    imageSrc={item.image}
                    altText={item?.title}
                    captionText={item?.name}
                    imageWidth="100%"
                    rotateAmplitude={12}
                    scaleOnHover={1}
                    showMobileWarning={false}
                    showTooltip={true}
                    displayOverlayContent={true}
                    overlayContent={
                      <>
                        <p
                          className="tilted-card-demo-text"
                          style={{ color: item.color }}
                        >
                          {item?.title}
                        </p>
                        <h4
                          className="tilted-card-title-text"
                          style={{ color: item.color }}
                        >
                          {item?.name}
                        </h4>
                      </>
                    }
                  />
                </Link>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default PortfolioPage;
